import { React, useState, useEffect, useRef } from "react";
import { PipeDesign, TableLayoutData } from "../../Pages/styledElements";
import { getShortJobCardCylinders } from "../../Services/deckleMatchServices";
import JobCardCylinder from "./JobCardCylinder";
import { TableList, RadioButtonStyle } from "../../Pages/pageStyled";
import { HaberForm } from "../../Pages/styledElements";
import Iconmoon from "../IconsFiles/icon";
import { Radio, Table, Tooltip } from "antd";
import moment from "moment";
import { lengthUnit } from "../../Utils/Constant/MeasurementUnitList";

function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}

// const cylinderColumnHead = [
//   {
//     title: "1",
//     dataIndex: "1",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "2",
//     dataIndex: "2",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "3",
//     dataIndex: "3",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "4",
//     dataIndex: "4",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "5",
//     dataIndex: "5",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "Total",
//     dataIndex: "total",
//     width: "0.01%",
//     align: "center",
//   },
//   {
//     title: "Trim",
//     dataIndex: "trim",
//     width: "0.01%",
//     align: "center",
//   },
//   {
//     title: "Del Date",
//     dataIndex: "deldate",
//     width: "0.1%",
//     align: "center",
//   },
//   {
//     title: "Sets",
//     dataIndex: "sets",
//     width: "0.01%",
//     align: "center",
//   },
// ];

const gridViewData = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in grid mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "grid",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in tabular mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="table" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "list",
  },
];
const cylinderMode = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in order mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="order-entry-icon" size={20} color="#EA655B" />
        
      </Tooltip>
    ),
    value: "order",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in production mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="production-icon" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "production",
  },
  
];

// const gridViewData = [
//   {
//     label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
//     value: "grid",
//   },
//   { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
// ];

const JobCardCylinderContainer = ({
  // cylinderData,
  jobId,
  solution,
  multiView,
  deckle_match_page = false,
  print_function = null,
  isValidState = false,
  // setGridView,
  // gridView,
  cancelSetToggle,
  reFetch = false,
  solId = "1",
  collapse = true,
  isPrintDisabled = false
}) => {
  const [gridView, setGridView] = useState(true);
  const [cylinderViewData, setCylinderViewData] = useState('order');
  const [cylinderData, setCylinderData] = useState();
  const cylinderColumnHead = useRef([]);
  const solutionId =
    solution === 1 ? "solution_1" : solution === 2 ? "solution_2" : null;
  const [isSetChanged, setIsSetChanged] = useState(false);
  useEffect(() => {
    if (cancelSetToggle) cancelSetToggle();
  }, [isSetChanged]);
  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
  // useEffect(() => {
  //   if (cylinderData && cylinderData[solutionId]) {
  //     const minSumWidth =
  //     );
  //   }
  // }, [cylinderData, solutionId]);
  const handleCheckAvailableWidth = () => {
    const spanElement = document.getElementById(`cylinder-container`);
    // console.log(spanElement, document);
    if (spanElement) {
      const pixels = spanElement.offsetWidth;

      return pixels;
    }
    return "";
  };
  useEffect(() => {
    handleCheckAvailableWidth();
  }, [collapse]);
  const calcMaxWidth = () => {
    const max = Math.max(
      ...cylinderData[solutionId].map((item) =>
        item.orders.reduce((sum, order) => sum + order.width, 0)
      )
    );
    const maxReels =
      Math.max(...cylinderData[solutionId].map((item) => item.orders.length)) -
      1;

    const maxDiff = Math.max(
      ...cylinderData[solutionId].map(
        (item) => max - item.orders.reduce((sum, order) => sum + order.width, 0)
      )
    );
    // console.log(
    //   "Max diff:",
    //   maxDiff,
    //   " \nMax width: ",
    //   max,
    //   " \nmax reels:",
    //   maxReels
    // );
    return { max, maxDiff, maxReels };
  };
  
  const dataSet =
    cylinderData &&
    solutionId &&
    cylinderData[solutionId]?.map((item, index) => {
      // console.log(item);
      let totalWidth = 0;
      item.orders?.forEach((current) => {
        totalWidth = current.order_width
          ? totalWidth +
            (current.grain == "long"
              ? current.order_width > current.order_length
                ? current.order_length
                : current.order_width
              : current.order_length > current.order_width
              ? current.order_length
              : current.order_width)
          : totalWidth;
      });
      let ordersToShowInTable = {
        // console.log(item);
        key: index + 1,
        total:
          totalWidth.toFixed(3) +
          " " +
          (cylinderData?.units
            ? capitalize(
                lengthUnit[cylinderData.units.order_width]?.displayName
              )?.toUpperCase()
            : ""),
        trim:
          item.trim_loss +
          " " +
          (cylinderData?.units
            ? lengthUnit[
                cylinderData.units.trim_loss
              ]?.displayName?.toUpperCase()
            : ""),
        reelSpecification: `${
          item.reel_od
        } ${cylinderData?.units?.reel_od?.toUpperCase()} / ${
          item.core_id
        } ${cylinderData?.units?.core_id?.toUpperCase()}`,
        deldate: moment(item.delivery_date).format("DD MMM YYYY"),
        sets: item.count,
        combination: index + 1,
      };
      let columnHeads = cylinderColumnHead.current;
      item.orders?.forEach((order, index) => {
        if (order.item_type !== "trim_loss") {
          ordersToShowInTable[+(index + 1)] = order?.order_width
            ? (order.grain == "long"
                ? order.order_width > order.order_length
                  ? order.order_length
                  : order.order_width
                : order.order_length > order.order_width
                ? order.order_length
                : order.order_width) +
              " " +
              (cylinderData?.units
                ? lengthUnit[
                    cylinderData.units.order_width
                  ]?.displayName?.toUpperCase()
                : "")
            : 0 +
              " " +
              (cylinderData?.units
                ? lengthUnit[
                    cylinderData.units.order_width
                  ]?.displayName?.toUpperCase()
                : "");
        }
      });
      
      if (columnHeads.length < item.orders.length + 6) {
        item.orders?.forEach((order, index) => {
          columnHeads[0] = {
            title: "Combination No.",
            dataIndex: "combination",
            width: "0.005%",
            align: "center",
          };
          // if (order.item_type !== "trim_loss") {
            columnHeads[index + 1] = {
              title: +(index + 1),
              dataIndex: +(index + 1),
              width: "0.02%",
              align: "center",
            };
          // }
          // else {
          //   columnHeads[index + 1] = {
          //     title: +(index + 1),
          //     dataIndex: "",
          //     width: "0.02%"
          //   }
          // }
          if (index == item.orders.length - 1) {
            columnHeads[index + 1 + 1] = {
              title: "Total ",
              dataIndex: "total",
              width: "0.01%",
              align: "center",
            };
            columnHeads[index + 1 + 2] = {
              title: "Trim",
              dataIndex: "trim",
              width: "0.01%",
              align: "center",
            };
            columnHeads[index + 1 + 3] = {
              title: "REEL SPECIFICATION (Reel Dia/Core Dia)",
              dataIndex: "reelSpecification",
              width: "0.1%",
              align: "center",
            };
            columnHeads[index + 1 + 4] = {
              title: "Del Date",
              dataIndex: "deldate",
              width: "0.1%",
              align: "center",
            };
            columnHeads[index + 1 + 5] = {
              title: "Sets",
              dataIndex: "sets",
              width: "0.01%",
              align: "center",
            };
          }
        });
      }
      const totalColumnCount = columnHeads.filter((item) => {
        return item.dataIndex === "total";
      });
      if (totalColumnCount.length > 1) {
        let index = -1;
        var filteredObj = columnHeads.find(function (item, i) {
          if (item.dataIndex === "total") {
            index = i;
            return i;
          }
        });
        columnHeads.splice(index, 1);
      }

      return ordersToShowInTable;
    });

  // console.log("cylinder", cylinderData);
  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "grid") {
      setGridView(true);
    } else {
      setGridView(false);
    }
    // console.log("view check", e.target.value);
  };
  const handleCylinderViewChange = (e) => {
    if (e.target.value === "production") {
      setCylinderViewData('production');
    } else {
      setCylinderViewData('order');
    }
  }
  function mergeReels(data) {
  const merged = [];
  const visited = new Array(data.length).fill(false);

  for (let i = 0; i < data.length; i++) {
    if (visited[i]) continue;

    let item = data[i];

    const itemOrders = item.orders.filter(o => o.item_type === "order");

    let total_order_width = itemOrders.reduce(
      (a, b) => a + b.order_width,
      0
    );

    // Clone first occurrence (delivery_date preserved automatically)
    let newItem = {
      ...item,
      orders: [...item.orders]
    };

    visited[i] = true;

    for (let j = i + 1; j < data.length; j++) {
      if (visited[j]) continue;

      let compareItem = data[j];

      const compareOrders = compareItem.orders.filter(
        o => o.item_type === "order"
      );

      let total_compare_order_width = compareOrders.reduce(
        (a, b) => a + b.order_width,
        0
      );

      const ordersSame =
        itemOrders.length === compareOrders.length &&
        itemOrders.every((ele, index) =>
          ele.order_width === compareOrders[index]?.order_width &&
          ele.order_type === compareOrders[index]?.order_type
        );

      if (
        total_order_width === total_compare_order_width &&
        item.trim_loss === compareItem.trim_loss &&
        item.reel_od === compareItem.reel_od &&
        item.core_id === compareItem.core_id &&
        ordersSame
      ) {
        // Merge counts
        newItem.count += compareItem.count;
        newItem.actual_count += compareItem.actual_count;
        newItem.cancelled_count += compareItem.cancelled_count;

        visited[j] = true;
      }
    }

    merged.push(newItem);
  }

  return merged;
}
  useEffect(() => {
    var screen_width = window.screen.width;
    var divisor = 3;
    if (screen_width <= 1366) {
      if (deckle_match_page) {
        divisor = 3.8;
      } else {
        divisor = 4;
      }
    } else if (screen_width > 1366 && screen_width <= 1920) {
      divisor = 3.2;
    }
    var w = window.outerWidth / divisor;
    getShortJobCardCylinders(jobId, w)
      .then((response) => {
        // console.log(response);
        if (cylinderViewData === 'production') {
          const data = mergeReels(response[solutionId]);
          setCylinderData({ ...response, [solutionId]: data });
        }
        else{
          setCylinderData(response);
        }
        
      })
      .catch((error) => {
        console.log(error);
      });

    return () => {
      setCylinderData(null);
    };
  }, [jobId, isSetChanged, reFetch, solId,cylinderViewData]);

  return jobId ? (
    <PipeDesign>
      <div className="main-container" id="cylinder-container">
        <TableList>
          <div className="radioSwitchStyle" style={{ zIndex: 10 }}>
            <div className="table-view">
              {/* add print icon to print jobcard details */}
              {!deckle_match_page && !isPrintDisabled && (
                <div className="List-grid-View" onClick={print_function}>
                  <div className="printIcon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                        fill="#605E5C"
                      />
                    </svg>
                  </div>
                </div>
              )}

              <HaberForm>
                <div style={{display:"flex",columnGap:"10px"}}>
                <RadioButtonStyle>
                  <div
                    className="boxFormType switchRadio"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Radio.Group
                      options={cylinderMode}
                      onChange={handleCylinderViewChange}
                      value={cylinderViewData}
                      optionType="button"
                      buttonStyle="solid"
                      className={cylinderViewData === "production" ? "ListViewActive" : "gridViewActive"}
                    />
                  </div>
                </RadioButtonStyle>
                <RadioButtonStyle>
                  <div
                    className="boxFormType switchRadio"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Radio.Group
                      options={gridViewData}
                      onChange={handleViewChange}
                      value={gridView}
                      optionType="button"
                      buttonStyle="solid"
                      className={gridView ? "gridViewActive" : "ListViewActive"}
                    />
                  </div>
                </RadioButtonStyle>
                </div>
              </HaberForm>
            </div>
          </div>
        </TableList>

        {/* {solution == 1
          ? 
          : cylinderData.solution_2.map((item) => (
              <tr>
                <JobCardCylinder cylinderData={item} />{" "}
              </tr>
            ))} */}

        {gridView ? (
          cylinderData &&
          cylinderData[solutionId]?.map((item, index) => (
            <tr>
              <JobCardCylinder
                cylinderData={item}
                multiview={multiView}
                units={cylinderData.units}
                isValidState={isValidState}
                jobId={jobId}
                cancelSetToggle={() => setIsSetChanged(!isSetChanged)}
                deckle_match_page={deckle_match_page}
                maxWidth={calcMaxWidth()}
                combinationNumber={index + 1}
                solution={solutionId}
                solId={solId}
                maxAvailableWidth={handleCheckAvailableWidth()}
              />
            </tr>
          ))
        ) : (
          // <JobCardCylinderContainer
          //   cylinderData={cylinderData}
          //   solution={1}
          //   setGridView={setGridView}
          //   gridView={gridView}
          // />
          <div className="list-grid-view">
            <TableLayoutData>
              <div className="tableDataFormat removePagnation">
                <Table
                  columns={cylinderColumnHead.current}
                  dataSource={dataSet}
                  onChange={onChange}
                  scroll={{
                    x:
                      window.screen.width < 1000 &&
                      cylinderColumnHead.current.length * 1.2,
                  }}
                  pagination={false}
                />
              </div>
            </TableLayoutData>
          </div>
        )}
      </div>
    </PipeDesign>
  ) : null;
};

export default JobCardCylinderContainer;
